import { render, staticRenderFns } from "./CalendariosMidiaSociais.vue?vue&type=template&id=6a05fc12"
import script from "./CalendariosMidiaSociais.vue?vue&type=script&lang=js"
export * from "./CalendariosMidiaSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports